import React from 'react'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../AssetHelpers'

type Props = {
  className?: string
  path: string
  svgClassName?: string
}

const KTSVG: React.FC<Props> = ({ className = '', path, svgClassName = 'mh-50px' }) => {
  const srcPath = toAbsoluteUrl(path) // Memoize path computation
  const iconClass = `svg-icon ${className}`.trim() // Avoid redundant spaces

  return (
    <span className={iconClass}>
      <SVG src={srcPath} className={svgClassName} />
    </span>
  )
}

export { KTSVG }
